import React, { useState } from 'react';
import AddPatientModal from './AddPatientModal';
import './Patients.css'; // Import the CSS file
import initialPatients from './initialPatientData';

const Patients = () => {
    const [patients, setPatients] = useState(initialPatients);
    const [selectedPatient, setSelectedPatient] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const addPatient = (newPatient) => {
        newPatient.id = patients.length + 1; // Simple ID assignment
        setPatients([...patients, newPatient]);
        setShowModal(false);
    };

    return (
        <div style={styles.container}>
            {showModal && <div style={styles.overlay}></div>}
            <div className="listContainer">
                <div className="buttonContainer">
                    <button className="button addPatientButton" onClick={() => setShowModal(true)}>Add Patient</button>
                </div>
                <h2>Patients</h2>
                <ul style={styles.list}>
                    {patients.map(patient => (
                        <li
                            key={patient.id}
                            style={selectedPatient && selectedPatient.id === patient.id ? styles.selectedItem : styles.listItem}
                            onClick={() => setSelectedPatient(patient)}
                        >
                            {`${patient.firstName} ${patient.middleName} ${patient.lastName}`}
                        </li>
                    ))}
                </ul>
            </div>
            <div style={styles.detailsContainer}>
                {selectedPatient && (
                    <div style={styles.details}>
                        <h3>Details</h3>
                        <p><strong>Patient ID:</strong> {selectedPatient.patientId}</p>
                        <p><strong>First Name:</strong> {`${selectedPatient.firstName}`}</p>
                        <p><strong>Middle Name:</strong> {`${selectedPatient.middleName}`}</p>
                        <p><strong>Last Name:</strong> {`${selectedPatient.lastName}`}</p>
                        <p><strong>Date of Birth:</strong> {selectedPatient.dob}</p>
                        <p><strong>Gender with Insurance:</strong> {selectedPatient.genderWithInsurance}</p>
                        <p><strong>Phone Number:</strong> {selectedPatient.phoneNumber}</p>
                        <p><strong>Email:</strong> {selectedPatient.email}</p>
                        <p><strong>Street Address:</strong> {`${selectedPatient.address}`}</p>
                        <p><strong>City:</strong> {`${selectedPatient.city}`}</p>
                        <p><strong>State:</strong> {`${selectedPatient.state}`}</p>
                        <p><strong>Zip:</strong> {`${selectedPatient.zip}`}</p>
                        <p><strong>Referring Physician:</strong> {selectedPatient.referringPhysician}</p>
                        <p><strong>Diagnosis:</strong> {selectedPatient.diagnosis}</p>
                        <p><strong>Number of Requested Visits:</strong> {selectedPatient.numberOfRequestedVisits}</p>
                        <p><strong>Treatment Notes:</strong> {selectedPatient.treatmentNotes}</p>
                    </div>
                )}
            </div>
            {showModal && <AddPatientModal onSave={addPatient} onCancel={() => setShowModal(false)} />}
        </div>
    );
};

const styles = {
    container: {
        display: 'flex',
        height: '88vh',
        position: 'relative',
    },
    listContainer: {
        width: '33.33%',
        padding: '10px',
        boxSizing: 'border-box',
        overflowY: 'auto',
        height: '100%',
    },
    list: {
        listStyleType: 'none',
        padding: 0,
        marginTop: '20px',
    },
    listItem: {
        padding: '10px',
        cursor: 'pointer',
        borderBottom: '1px solid gray',
    },
    selectedItem: {
        padding: '10px',
        cursor: 'pointer',
        borderBottom: '1px solid gray',
        backgroundColor: 'lightblue',
    },
    detailsContainer: {
        width: '66.67%',
        padding: '20px',
        boxSizing: 'border-box',
        overflowY: 'auto',
        height: '100%',
    },
    overlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: 2,
    },
    addButton: {
        display: 'block',
        margin: '10px 0',
    },
};

export default Patients;